export default function ProductDirective() {
  return {
    template: require('./product.html'),
    controller: 'ProductController',
    controllerAs: 'productVM',
    scope: {
      vendor: '=',
      product: '=',
      filters: '=',
      deleteCallback: '&'
    },
    bindToController: true,
    replace: true,
  };
}
